import React from "react";
import PropTypes from 'prop-types';
import Media from "../Carousel/CarouselMedia";
import Typography from "../Typography";

const BottomBanner = ({ title, footerText, listItem, isNoWidth }) => {
    const classnames = listItem && listItem?.length > 1 ? 'bottom-banner mb-10 w-full grid grid-col-1 md:grid-cols-2 gap-5 mb-0 relative' : 'bottom-banner mb-10 w-full grid grid-col-1 gap-5 mb-0 relative';
    return <div className={classnames}>
        {
            listItem && listItem.map((item, index) => (
                <div key={index} className="col-span-1 relative">
                    <Media
                        isLazyLoad
                        component="bannerPicture"
                        srcset={item?.imageSet?.desktopImage?.url}
                        image={item?.imageSet?.smartphoneImage?.url}
                        altText={item?.imageSet.altText}
                        priority={true}
                        isNoWidth={isNoWidth}
                        className="w-full object-cover object-center"
                    />
                    <Typography component="h2" className="color-gradient-yellow-stack font-NanumGothic text-20 md:text-40 text-center absolute top-10 left-0 md:tracking-wider2x right-0 font-medium bottomHeading" 
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.text)
                      }} />
                </div>
            ))
        }
        {title && <div className="footer-subtitle absolute bottom-60 right-10 md:right-30 w-1/2 md:w-1/4 xl:w-1/6 footerTitle">
            <h4 className="text-white font-HelveticaNeueBold font-extrabold text-15 md:text-1.7rm md:leading-30 text-right">
                {title}
            </h4>
        </div>
        }
        {footerText && <div className="absolute bottom-10 right-10 w-95p md:w-[45%]">
            <p className="text-white text-.6rm leading-10 text-right">
                {footerText}
            </p>
        </div>}
    </div>;
};

BottomBanner.propTypes = {
    title: PropTypes.string,
    footerText: PropTypes.string,
    listItem: PropTypes.array
};

export default BottomBanner;